module.exports = __webpack_public_path__ + "img/election_symbol.a0366b0e.png";